import request from '@/utils/request'
const PURCHASE_API = process.env.VUE_APP_PURCHASE_API
// const PURCHASE_API = 'http://127.0.0.1:4523/m1/2483590-0-default'

// 开启线上评审
export function startNegotiationReviewApi(reviewId, params, data) {
  return request({
    url:
      PURCHASE_API + `/workbench/purchaser/negotiate-reviews/${reviewId}/start`,
    method: 'post',
    params,
    data
  })
}

// 查询采购单信息
export function getNegotiationReviewOrderApi(reviewId, orderId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/review-orders/${orderId}/info`,
    method: 'get'
  })
}

// 查询评审供应商列表
export function getNegotiationReviewSupplierListApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/review-suppliers/list`,
    method: 'get',
    params
  })
}

// 查询供应商的报价列表
export function getNegotiationReviewSupplierQuoteRoundListApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/supplier-offers/list`,
    method: 'get',
    params
  })
}

// 分页查询打分表
export function getNegotiationReviewScorePageApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/review-scores/page`,
    method: 'get',
    params
  })
}

// 查询综合排序表信息
export function getNegotiationReviewRankPageApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/review-ranks/page`,
    method: 'get',
    params
  })
}

// 获取供应商的报价文件预览地址
export function getNegotiationReviewQuoteFileApi({
  reviewId,
  orderId,
  supplierId,
  fileType
}) {
  const params = { orderId, supplierId, fileType }
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/review-scores/offer-file`,
    method: 'get',
    params
  })
}

/**
 * 最低价汇总评审办法
 */
export function submitNegotiationReviewByQuoteSummaryApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/way-scores/summary`,
    method: 'post',
    params
  })
}

/**
 * 分页查询所有供应商的轮次报价列表
 */
export function getNegotiationReviewQuoteRoundPageApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/negotiate-reviews/${reviewId}/round-offers/page`,
    method: 'get',
    params
  })
}
